"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _StepperValueHeader = _interopRequireDefault(require("./StepperValueHeader"));
var _StepperValue = _interopRequireDefault(require("./StepperValue.style"));
var _StepperMember = _interopRequireDefault(require("./StepperMember"));
var _button = require("../../button");
var _helpers = require("./helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var FormulaValue = function FormulaValue(props) {
  var errors = props.errors,
    rule = props.rule,
    labels = props.labels,
    ruleIndex = props.ruleIndex,
    ruleChange = props.ruleChange,
    actions = props.actions,
    setHasChanges = props.setHasChanges,
    formulaOtherProps = props.formulaOtherProps;
  var stepperErrors = errors.stepper;
  var steps = rule.stepper.activeType === _helpers.ACTIVE_TYPES.fixed ? rule.stepper[_helpers.ACTIVE_TYPES.fixed].steps : rule.stepper[_helpers.ACTIVE_TYPES.percentage].steps;
  var ruleUpdate = function ruleUpdate(index) {
    return function (value) {
      var newValue = _toConsumableArray(R.path(['stepper', rule.stepper.activeType, 'steps'], rule));
      newValue[index] = _objectSpread(_objectSpread({}, steps[index]), value);
      ruleChange('stepper', _objectSpread(_objectSpread({}, rule.stepper), {}, _defineProperty({}, rule.stepper.activeType, {
        steps: newValue
      })));
    };
  };
  var addRule = function addRule() {
    ruleUpdate(steps.length)((0, _helpers.emptyRule)());
  };
  var removeStep = function removeStep(index) {
    var currentValue = _toConsumableArray(R.path(['stepper', rule.stepper.activeType, 'steps'], rule));
    ruleChange('stepper', _objectSpread(_objectSpread({}, rule.stepper), {}, _defineProperty({}, rule.stepper.activeType, {
      steps: R.remove(index, 1, currentValue)
    })));
  };
  return /*#__PURE__*/_react["default"].createElement(_StepperValue["default"], {
    "data-testid": "stepper-value-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_StepperValueHeader["default"], {
    rule: rule,
    ruleIndex: ruleIndex,
    ruleChange: ruleChange,
    labels: labels,
    actions: actions,
    setHasChanges: setHasChanges
  }), steps.map(function (step, index) {
    return /*#__PURE__*/_react["default"].createElement(_StepperMember["default"], _extends({}, formulaOtherProps, {
      key: step.key,
      data: step,
      error: stepperErrors && stepperErrors[rule.stepper.activeType][index],
      index: index,
      labels: labels,
      ruleChange: ruleUpdate(index),
      removeStep: removeStep,
      setHasChanges: setHasChanges
    }));
  }), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    type: "naked",
    icon: "ion-android-add",
    className: "stepper-button-add",
    action: addRule
  }, labels.STEP_ADD));
};
FormulaValue.defaultProps = {
  errors: {},
  formulaOtherProps: {}
};
FormulaValue.propTypes = {
  ruleIndex: _propTypes["default"].number.isRequired,
  rule: _propTypes["default"].shape({
    stepper: _propTypes["default"].shape({
      activeType: _propTypes["default"].string
    })
  }).isRequired,
  errors: _propTypes["default"].shape({
    stepper: _propTypes["default"].shape({})
  }),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  formulaOtherProps: _propTypes["default"].shape({}),
  actions: _propTypes["default"].shape({
    deleteRuleBlock: _propTypes["default"].func
  }).isRequired,
  setHasChanges: _propTypes["default"].func.isRequired
};
FormulaValue.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormulaValue",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "stepper": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "formulaOtherProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "rule": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "stepper": {
            "name": "shape",
            "value": {
              "activeType": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "ruleChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "deleteRuleBlock": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": true
    },
    "setHasChanges": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = FormulaValue;
exports["default"] = _default;